/* global define:true */

define([
	'jquery',
	'underscore',
	'BaseView',
	'backbone',
	'widgets/sidepanel',
	'widgets/accessibleModal'

], function ($, _, BaseView, Backbone, SidePanelView) {

	'use strict';

	var View = BaseView.extend({

		el: '.js_notificationButtonView',
		events: {
			'click .js_notifications-toggleTrigger': 'toggleSidePanel'
		},

		initialize: function () {
			var autoDisplay = this.$el.data() && this.$el.data().autodisplay;

			this.notificationSidePanel = new SidePanelView({
				el: '.js_globalNotifs-sidepanel',
				events: _.extend(
					{},
					SidePanelView.prototype.events,
					{'click .js_closeNotifications': this.toggleSidePanel.bind(this)},
					{'click .js_dismissNotification': this.dismissNotification.bind(this)}
				)
			});

			if (autoDisplay) {
				this.toggleSidePanel();
			}
		},

		toggleSidePanel: function (event) {
			if (event) {
				event.preventDefault();
			}
			this.notificationSidePanel.toggleSidePanel();
		},

		/*
		* Dismiss a notification or alert if it can be removed.
		*/
		dismissNotification: function (event) {
			event.preventDefault();

			var postParams = {},
				dismissNotificationUrl = Backbone.history.options.root + 'notifications/dismissNotification',
				$dismissItem = $(event.currentTarget),
				id = $dismissItem.attr('id'),
				$notificationCountSelector = $('.js_notificationCount'),
				notificationCount = $notificationCountSelector.first().text();

			postParams.notificationId = id;
			/*
			 * Updates the notification count, and removes the dismissed notification from the view
			 */
			function updateNotifications(response) {
				if (response.statusCode === 'success') {
					if (notificationCount && !isNaN(notificationCount)) {
						--notificationCount;
						// if the last notification is dismissed,
						// then add a class that hides the number of notification on the bell icon and close the sidepanel
						if (notificationCount < 1) {
							$notificationCountSelector.addClass('notificationLength-0');
							this.notificationSidePanel.toggleSidePanel();
						}
						// update the notification count
						$notificationCountSelector.text(notificationCount);
					}
					// removes the notification from the sidepanel
					$dismissItem.parents('.js_notificationItem').remove();
				}
			}

			$.ajax({
				method: 'POST',
				timeout: 5000,
				url: dismissNotificationUrl,
				data: postParams,
				success: updateNotifications.bind(this),
				ignoreErrors: true
			});
		}
	});

	return View;

});



//////////////////
// WEBPACK FOOTER
// ./view/notification.js
// module id = 871
// module chunks = 0